<template>
  <el-dialog title="修改密码" :visible.sync="dialogVisible" width="460px" append-to-body
    :close-on-click-modal="false" @closed="resetForm">
    <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="90px">
      <el-form-item label="原密码" prop="old_password">
        <el-input v-model="pwdForm.old_password" type="password" show-password placeholder="请输入原密码" />
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input v-model="pwdForm.new_password" type="password" show-password placeholder="6-72 位" />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirm_password">
        <el-input v-model="pwdForm.confirm_password" type="password" show-password placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { changePassword } from '@/api/auth'

export default {
  name: 'ChangePasswordDialog',
  data() {
    // 确认密码一致性校验
    const validateConfirm = (rule, value, cb) => {
      if (value !== this.pwdForm.new_password) {
        cb(new Error('两次输入的密码不一致'))
      } else {
        cb()
      }
    }
    return {
      dialogVisible: false,
      loading: false,
      pwdForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      pwdRules: {
        old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 72, message: '密码长度 6-72 位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    resetForm() {
      this.pwdForm = { old_password: '', new_password: '', confirm_password: '' }
      this.$refs.pwdForm && this.$refs.pwdForm.clearValidate()
    },
    handleSubmit() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await changePassword({
            old_password: this.pwdForm.old_password,
            new_password: this.pwdForm.new_password,
            confirm_password: this.pwdForm.confirm_password
          })
          this.$message.success('密码修改成功，请重新登录')
          this.dialogVisible = false
          // 后端已清除 Token 缓存，前端清空本地并跳登录页（hash 模式整页刷新）
          setTimeout(() => {
            this.$store.commit('user/RESET_USER')
            window.location.hash = '#/login'
            window.location.reload()
          }, 1000)
        } catch (e) {
          // 拦截器已提示
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
